import TeamList from '../components/team/TeamList';

import { PageTitle } from '../../../../_metronic/layout/core';

export default function TeamsPage() {
  return (
    <>
      <PageTitle>DevOps - Gerenciamento de Equipes</PageTitle>
      <TeamList />
    </>
  );
}
